import { useRef } from "react";
import { getTrace } from "util/trace";
import { shallow as shallowEqual } from "zustand/vanilla/shallow";

const DEBUG_MEMO = false;

/**
 * Memoize a computation under a one-level deep shallow comparison.
 */
export function useShallowMemo<T>(fn: () => T): T {
  const prev = useRef<T>(null);
  const next = fn();
  if (!shallowEqual(prev.current, next)) {
    if (DEBUG_MEMO) {
      console.log(
        ...getTrace()
          .slice(0, 3)
          .map((x) => x.methodName),
        prev.current,
        next
      );
    }
    prev.current = next;
  }
  return prev.current as T;
}
